import Ajax from './Ajax.js'

const Emission = {
  getEmissions: (id = null) => {
    let uri = id !== null
      ? '/emissions' + '/' + id
      : '/emissions'
    return Ajax.get(uri)
  },

  postEmissions: (params) => {
    const payload = params && params.data ? params : {
      data: {
        area: params.area,
        date: params.date,
        concept: params.concept,
        tonCo2: params.tonCo2 !== undefined ? parseFloat(params.tonCo2) : (params.ton_co2 !== undefined ? parseFloat(params.ton_co2) : undefined),
        notes: params.notes
      }
    }
    return Ajax.post('/emissions', payload)
  },

  delEmissions: (id) => {
    return Ajax.delete('/emissions/' + id)
  }
}

export default Emission
